import { ChevronDown, PiggyBankIcon, TimerIcon } from "lucide-react";

import { cn } from "shared/lib";

export interface SubdivisionTimelineItemHeadingProps {
  isOpen?: boolean;
  title: string;
  timeframe: string;
  cost?: string | undefined | null;
}

export function SubdivisionTimelineItemHeading({
  isOpen,
  title,
  timeframe,
  cost,
}: SubdivisionTimelineItemHeadingProps) {
  return (
    <div className="flex flex-col">
      <div className="text-textLink text-headingmd flex items-center hover:underline">
        {title}
        <ChevronDown
          className={cn("ml-1 size-4 transition-transform duration-200", {
            "rotate-180": isOpen,
          })}
        />
      </div>
      <p className="text-bodymd text-textSubdued flex items-center gap-2">
        <span className="flex items-center gap-1">
          <TimerIcon className="size-4" />
          <span>{timeframe}</span>
        </span>
        {typeof cost === "string" && cost.length > 0 && (
          <span className="flex items-center gap-1">
            <PiggyBankIcon className="size-4" />
            <span>{cost}</span>
          </span>
        )}
      </p>
    </div>
  );
}
